<!-- necesita ser SA? -->
<div class="row">
  <!-- Formulario -->
  <div class="col-6">
    <form [formGroup]="guestContactForm">
      <div class="row">
        <div class="col-12 wrapp_form">
          <label>{{'models.hotel_dto.guest_contact.phone' | translate}}</label>
          <input type="tel" id="phone" class="form-control" formControlName="phone">
          <small class="alert-danger" *ngIf="hasError('phone')">
            {{getErrorMessage('phone') | translate}}
          </small>
        </div>
        <div class="col-12 wrapp_form">
          <label>{{'models.hotel_dto.guest_contact.internal_reception_number' | translate}}</label>
          <input type="tel" id="internal_reception_number" class="form-control" formControlName="internal_reception_number">
          <small class="alert-danger" *ngIf="hasError('internal_reception_number')">
            {{getErrorMessage('internal_reception_number') | translate}}
          </small>
        </div>
        <div class="col-12 wrapp_form">
          <label>{{'models.hotel_dto.guest_contact.mobile_phone' | translate}}</label>
          <input type="tel" id="mobile_phone" class="form-control" formControlName="mobile_phone">
          <small class="alert-danger" *ngIf="hasError('mobile_phone')">
            {{getErrorMessage('mobile_phone') | translate}}
          </small>
        </div>
        <div class="col-12 wrapp_form">
          <label>{{'models.hotel_dto.guest_contact.email' | translate}}</label>
          <input type="email" id="email" class="form-control" formControlName="email">
          <small class="alert-danger" *ngIf="hasError('email')">
            {{getErrorMessage('email') | translate}}
          </small>
        </div>
        <div class="col-12 wrapp_form">
          <label>{{'models.hotel_dto.guest_contact.instagram' | translate}}</label>
          <input type="text" id="instagram" class="form-control" formControlName="instagram">
          <small class="alert-danger" *ngIf="hasError('instagram')">
            {{getErrorMessage('instagram') | translate}}
          </small>
        </div>
      </div>
    </form>
  </div>

  <!-- Icono y texto -->
  <div class="col-6 tw-flex tw-items-center tw-justify-center">
    <div class="tw-text-center">
      <i class="fas fa-exclamation-triangle tw-text-6xl tw-text-yellow-500 tw-mb-4"></i>
      <p class="tw-text-gray-600 tw-mt-4">{{'customer.configurations.hotel.form.warn-message' | translate}}</p>
    </div>
  </div>
</div>
